<template>
  <div class="document">
    <template>
      <div
        v-if="showModal"
        class="modal is-active"
      >
        <div class="modal-background"/>
        <div class="modal-card">
          <header class="modal-card-head">
            <strong class="modal-card-title">
              System Message
            </strong>
            <button
              class="icon is-right"
              @click.prevent="toggleModal()"
              ref="closeIcon"
            >
              <font-awesome-icon
                :icon="['fal', 'times']"
                title="Close"
              />
            </button>
          </header>
          <section class="modal-card-body">
            <div class="modal-body">
              {{ properties['SYSTEM_MESSAGE-MESSAGE'] }}
            </div>
            <div class="is-pulled-right">
              <button
                class="button button-link has-underline"
                @click.prevent="toggleModal()"
              >
                Close
              </button>
            </div>
          </section>
        </div>
      </div>
    </template>
    <div>
      <h3 class="title is-3 has-text-left">
        System Message
      </h3>
      <div
        v-if="`${this.properties['SYSTEM_MESSAGE-MESSAGE']}`.length < 181"
        class="has-text-left sys-message"
      >
        {{ properties['SYSTEM_MESSAGE-MESSAGE'] }}
      </div>
      <div v-else class="has-text-left sys-message">
        {{ properties['SYSTEM_MESSAGE-MESSAGE'].substring(0,180)+"..." }}
        <div class="has-text-right sys-message">
          <button
            class="button button-link has-underline"
            @click.prevent="toggleModal()"
            ref="linkView"
          >
            View More
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
} from '@fortawesome/pro-light-svg-icons';
import AccessibilityUtils from '@/mixins/AccessibilityUtils';

library.add(
  faTimes,
);

export default {
  mixins: [
    AccessibilityUtils,
  ],
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
      this.$nextTick(() => {
        const modalOpenFocus = this.$refs.closeIcon;
        const modalCloseFocus = this.$refs.linkView;
        this.getFocusModal(modalOpenFocus, modalCloseFocus);
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    padding: 1rem
    height: 100%
  .title
    margin-bottom: 0.5rem
  .sys-message
    font-size: 12px

  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
</style>
